import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
interface DrawerProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
  footer?: React.ReactNode;
  size?: 'sm' | 'md' | 'lg';
}
export const Drawer: React.FC<DrawerProps> = ({
  isOpen,
  onClose,
  title,
  children,
  footer,
  size = 'md'
}) => {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);
  const sizes = {
    sm: 'max-w-md',
    md: 'max-w-xl',
    lg: 'max-w-3xl'
  };
  return <AnimatePresence data-id="element-187">
      {isOpen && <>
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} onClick={onClose} className="fixed inset-0 bg-black/30 backdrop-blur-sm z-40" data-id="element-188" />
          <motion.div initial={{
        x: '100%'
      }} animate={{
        x: 0
      }} exit={{
        x: '100%'
      }} transition={{
        type: 'spring',
        damping: 25,
        stiffness: 200
      }} className={`fixed inset-y-0 right-0 z-50 w-full ${sizes[size]} bg-surface-primary shadow-elevation-4 flex flex-col border-l border-border-light`} data-id="element-189">
            <div className="flex items-center justify-between px-6 py-4 border-b border-border-light" data-id="element-190">
              <h2 className="text-lg font-semibold text-text-primary" data-id="element-191">
                {title}
              </h2>
              <button onClick={onClose} className="p-2 rounded-full hover:bg-surface-secondary text-text-secondary transition-colors" data-id="element-192">
                <XIcon className="w-5 h-5" data-id="element-193" />
              </button>
            </div>

            <div className="flex-1 overflow-y-auto p-6" data-id="element-194">{children}</div>

            {footer && <div className="px-6 py-4 border-t border-border-light bg-surface-secondary flex justify-end gap-3" data-id="element-195">
                {footer}
              </div>}
          </motion.div>
        </>}
    </AnimatePresence>;
};